import { render, staticRenderFns } from "./detailsInventorySurplus.vue?vue&type=template&id=13f30a51&scoped=true"
import script from "./detailsInventorySurplus.vue?vue&type=script&lang=js"
export * from "./detailsInventorySurplus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f30a51",
  null
  
)

export default component.exports